export default __webpack_public_path__ + "images/bc6012e28ab7c590524d6f2e44ae7f2a.svg";